import type { ProductInterface } from "magento-gql-types";

export function getProductName(product: ProductInterface | undefined) {
  if (product) {
    //@ts-ignore
    let name = product?.color_name ? product?.color_name : product?.name;
    return name;
  }
}
